import React, { useState } from 'react';
import omit from 'lodash/omit';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';

import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';

import { useCompetitions } from '../../contexts/Competitions';

const api = 'api/core/users/admins';

const ListAdmins = (props) => {
  const { school } = props;
  const { competitions } = useCompetitions();
  const [comp, setComp] = useState('');

  const filter = school
    ? { school, roles: 'schoolAdmin' }
    : { roles: 'admin' };

  if (comp) filter.competition = comp;

  const ctrls = school ? [
    <select
      className="custom-select"
      key={0}
      value={comp}
      onChange={(e) => setComp(e.target.value)}
    >
      <option value="">All Competitions</option>
      {competitions.map((c) => (
        <option
          key={c._id}
          value={c._id}
        >{c.refCode}</option>
      ))}
    </select>,
  ] : [];

  return (
    <ListResource
      {...{
        searchable: true,
        api,
        ctrls,
        sort: { 'name.full.en': 1 },
        filter,
        cols: [
          { key: 'name.full.en', children: 'Name', sortable: true },
          { key: 'name.full.zhhk', children: '姓名', sortable: true },
          {
            key: 'active',
            getter(v) {
              return (
                <FA icon={v ? faEye : faEyeSlash} />
              );
            },
          },
          { key: 'username', sortable: true },
        ],
        ...omit(props, 'school'),
      }}
    >
      {({ selected, refresh }) => (
        <ListCtrlActivates
          api={api}
          selected={selected}
          onSuccess={refresh}
        />
      )}
    </ListResource>
  );
};

export default ListAdmins;
